import http from '../request';

export function getGroupList(query = {}) {
  return http.get('/merchant/group/list', query);
}

// 登录
export function login(params = {}) {
  return http.post('/channel_admin/login', params);
}

// 登录
export function logout() {
  return http.get('/channel_admin/logout', {});
}

